import {TASKMANAGE} from 'Constants/ActionTypes';

const {
  GET_TASK_LIST_WORD_STRATEGY_ID_OPTIONS,
  GET_TASK_LIST_STRATEGY_OPTIONS,
  GET_TASK_LIST_PHONE_OPTIONS,
  GET_TASK_LIST_WORK_TIME_OPTIONS,
  SET_TASK_LIST_SEARCH_DATA,
  SET_TASK_LIST_TAB_ACTIVE_KEY,
  GET_TASK_LIST_LIST,
  SET_TASK_LIST_PAGE_STATUS,
  SET_TASK_LIST_EDIT_MODAL_DATA,
  CUSTOMIZE_SMG_TEMPLATES,
  GET_CUSTOMIZE_TASK_LIST,
  TASK_LIST_DEPT,
} = TASKMANAGE;

const initialState = {
  wordStrategyIdOptions: [], // 话术名称下拉框
  wordStrategyIdOptionList: [], // 话术名称根据部门筛选下拉框
  phoneOptions: [], // 主叫号码下拉框
  workTimeOptions: [], // 工作时间下拉框
  searchData: {
    progress: -1,
  }, // 搜索条件
  tabActiveKey: '-1', // tab的activeKey
  tableListData: {
    data: [],
    total: 0,
  }, // table数据
  pageStatus: {
    pageNum: 1,
    pageSize: 20,
  }, // pageNum与pageSize
  editModalData: {}, // 编辑弹框数据
  templates: [], // 短信模板下拉选接口
  treeData: [], // 部门树
  // treeData: [
  //   {
  //     has_children: true,
  //     children: [
  //       {
  //         has_children: true,
  //         children: [
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 2,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 8,
  //             title: '4567',
  //             value: 8,
  //           },
  //         ],
  //         dept_sort: 0,
  //         dept_pid: 1,
  //         vcc_id: 1,
  //         vcc_code: 'demo',
  //         id: 2,
  //         title: '213',
  //         value: 2,
  //       },
  //       {
  //         has_children: false,
  //         children: [],
  //         dept_sort: 0,
  //         dept_pid: 1,
  //         vcc_id: 1,
  //         vcc_code: 'demo',
  //         id: 14,
  //         title: '789',
  //         value: 14,
  //       },
  //       {
  //         has_children: true,
  //         children: [
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 26,
  //             title: '宁乡重起-咸阳泰瑞达',
  //             value: 26,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 32,
  //             title: '宁乡重起-甘肃天源',
  //             value: 32,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 38,
  //             title: '宁乡重起-宁夏三川',
  //             value: 38,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 44,
  //             title: '宁乡重起-新疆华誉',
  //             value: 44,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 50,
  //             title: '宁乡重起-云南肯瑞',
  //             value: 50,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 56,
  //             title: '宁乡重起-贵州大驰',
  //             value: 56,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 62,
  //             title: '宁乡重起-四川鹏烜',
  //             value: 62,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 68,
  //             title: '宁乡重起-四川中安信',
  //             value: 68,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 74,
  //             title: '宁乡重起-巴州邦立华',
  //             value: 74,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 80,
  //             title: '宁乡重起-重庆湘汇',
  //             value: 80,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 86,
  //             title: '宁乡重起-广西聚缘和',
  //             value: 86,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 92,
  //             title: '宁乡重起-深圳沃拓',
  //             value: 92,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 98,
  //             title: '宁乡重起-广州巨合',
  //             value: 98,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 104,
  //             title: '宁乡重起-广州山屹',
  //             value: 104,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 110,
  //             title: '宁乡重起-湖南大驰',
  //             value: 110,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 116,
  //             title: '宁乡重起-湖北鸿辉',
  //             value: 116,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 122,
  //             title: '宁乡重起-郑州合顺',
  //             value: 122,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 128,
  //             title: '宁乡重起-烟台宏力达',
  //             value: 128,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 134,
  //             title: '宁乡重起-临沂冠泰',
  //             value: 134,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 140,
  //             title: '宁乡重起-江西九象',
  //             value: 140,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 146,
  //             title: '宁乡重起-杭州九象',
  //             value: 146,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 152,
  //             title: '宁乡重起-厦门博威特',
  //             value: 152,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 158,
  //             title: '宁乡重起-唐山驰特',
  //             value: 158,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 164,
  //             title: '宁乡重起-南京凯雷',
  //             value: 164,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 170,
  //             title: '宁乡重起-连云港广德',
  //             value: 170,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 176,
  //             title: '宁乡重起-江苏振轩',
  //             value: 176,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 182,
  //             title: '宁乡重起-哈尔滨永德',
  //             value: 182,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 188,
  //             title: '宁乡重起-吉林锐众',
  //             value: 188,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 194,
  //             title: '宁乡重起-沈阳三益源',
  //             value: 194,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 200,
  //             title: '宁乡重起-大连金威特',
  //             value: 200,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 206,
  //             title: '宁乡重起-山西北起',
  //             value: 206,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 212,
  //             title: '宁乡重起-唐山泉源',
  //             value: 212,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 218,
  //             title: '宁乡重起-河北宝域',
  //             value: 218,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 20,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 224,
  //             title: '宁乡重起-华北宝思威',
  //             value: 224,
  //           },
  //         ],
  //         dept_sort: 0,
  //         dept_pid: 1,
  //         vcc_id: 1,
  //         vcc_code: 'demo',
  //         id: 20,
  //         title: '长沙宁乡重起总部',
  //         value: 20,
  //       },
  //       {
  //         has_children: false,
  //         children: [],
  //         dept_sort: 0,
  //         dept_pid: 1,
  //         vcc_id: 1,
  //         vcc_code: 'demo',
  //         id: 230,
  //         title: '三一互动营销中心',
  //         value: 230,
  //       },
  //       {
  //         has_children: false,
  //         children: [],
  //         dept_sort: 0,
  //         dept_pid: 1,
  //         vcc_id: 1,
  //         vcc_code: 'demo',
  //         id: 236,
  //         title: '三一重工国际总部服务热线',
  //         value: 236,
  //       },
  //       {
  //         has_children: false,
  //         children: [],
  //         dept_sort: 0,
  //         dept_pid: 1,
  //         vcc_id: 1,
  //         vcc_code: 'demo',
  //         id: 242,
  //         title: '董办服务配件组投诉',
  //         value: 242,
  //       },
  //       {
  //         has_children: false,
  //         children: [],
  //         dept_sort: 0,
  //         dept_pid: 1,
  //         vcc_id: 1,
  //         vcc_code: 'demo',
  //         id: 248,
  //         title: '长沙路机事业部',
  //         value: 248,
  //       },
  //       {
  //         has_children: true,
  //         children: [
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 254,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 260,
  //             title: '昆山重机-武汉九州龙',
  //             value: 260,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 254,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 266,
  //             title: '昆山重机-郑州湘元',
  //             value: 266,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 254,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 272,
  //             title: '昆山重机-临沂亚华',
  //             value: 272,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 254,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 278,
  //             title: '昆山重机-烟台宏通',
  //             value: 278,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 254,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 284,
  //             title: '昆山重机-江西中旺',
  //             value: 284,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 254,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 290,
  //             title: '昆山重机-广州巨和',
  //             value: 290,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 254,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 296,
  //             title: '昆山重机-福建闽瑞通',
  //             value: 296,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 254,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 302,
  //             title: '昆山重机-合肥湘元',
  //             value: 302,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 254,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 308,
  //             title: '昆山重机-杭州鼎腾',
  //             value: 308,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 254,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 314,
  //             title: '昆山重机-江苏力好',
  //             value: 314,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 254,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 320,
  //             title: '昆山重机-黑龙江三君',
  //             value: 320,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 254,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 326,
  //             title: '昆山重机-石家庄众力',
  //             value: 326,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 254,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 332,
  //             title: '昆山重机-宜昌博勒',
  //             value: 332,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 254,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 338,
  //             title: '昆山重机-包头弘达',
  //             value: 338,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 254,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 344,
  //             title: '昆山重机-山西三龙聚兴',
  //             value: 344,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 254,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 350,
  //             title: '昆山重机-承德鸿泰',
  //             value: 350,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 254,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 356,
  //             title: '昆山重机-广西山宁',
  //             value: 356,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 254,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 362,
  //             title: '昆山重机-湖南中旺',
  //             value: 362,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 254,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 368,
  //             title: '昆山重机-重庆国杰',
  //             value: 368,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 254,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 374,
  //             title: '昆山重机-云南睿德',
  //             value: 374,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 254,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 380,
  //             title: '昆山重机-陕西悦大',
  //             value: 380,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 254,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 386,
  //             title: '昆山重机-宁夏三益',
  //             value: 386,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 254,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 392,
  //             title: '昆山重机-甘肃成峰',
  //             value: 392,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 254,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 398,
  //             title: '昆山重机-张掖海峰',
  //             value: 398,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 254,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 404,
  //             title: '昆山重机-青海海畴',
  //             value: 404,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 254,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 410,
  //             title: '昆山重机-新疆京泓',
  //             value: 410,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 254,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 416,
  //             title: '昆山重机-吉林三君',
  //             value: 416,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 254,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 422,
  //             title: '昆山重机-四川盛和',
  //             value: 422,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 254,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 428,
  //             title: '昆山重机-贵州通程兄弟',
  //             value: 428,
  //           },
  //         ],
  //         dept_sort: 0,
  //         dept_pid: 1,
  //         vcc_id: 1,
  //         vcc_code: 'demo',
  //         id: 254,
  //         title: '江苏昆山重机总部',
  //         value: 254,
  //       },
  //       {
  //         has_children: false,
  //         children: [],
  //         dept_sort: 0,
  //         dept_pid: 1,
  //         vcc_id: 1,
  //         vcc_code: 'demo',
  //         id: 434,
  //         title: '三一员工服务中心(IT帮助台)',
  //         value: 434,
  //       },
  //       {
  //         has_children: false,
  //         children: [],
  //         dept_sort: 0,
  //         dept_pid: 1,
  //         vcc_id: 1,
  //         vcc_code: 'demo',
  //         id: 440,
  //         title: '三一物流',
  //         value: 440,
  //       },
  //       {
  //         has_children: false,
  //         children: [],
  //         dept_sort: 0,
  //         dept_pid: 1,
  //         vcc_id: 1,
  //         vcc_code: 'demo',
  //         id: 446,
  //         title: '长沙泵送事业部',
  //         value: 446,
  //       },
  //       {
  //         has_children: false,
  //         children: [],
  //         dept_sort: 0,
  //         dept_pid: 1,
  //         vcc_id: 1,
  //         vcc_code: 'demo',
  //         id: 452,
  //         title: '三一快而居公司',
  //         value: 452,
  //       },
  //       {
  //         has_children: false,
  //         children: [],
  //         dept_sort: 0,
  //         dept_pid: 1,
  //         vcc_id: 1,
  //         vcc_code: 'demo',
  //         id: 458,
  //         title: '公司总部',
  //         value: 458,
  //       },
  //       {
  //         has_children: false,
  //         children: [],
  //         dept_sort: 0,
  //         dept_pid: 1,
  //         vcc_id: 1,
  //         vcc_code: 'demo',
  //         id: 464,
  //         title: '三一物联网（租赁平台）',
  //         value: 464,
  //       },
  //       {
  //         has_children: true,
  //         children: [
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 470,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 472,
  //             title: '测试三一重卡下级节点',
  //             value: 472,
  //           },
  //         ],
  //         dept_sort: 0,
  //         dept_pid: 1,
  //         vcc_id: 1,
  //         vcc_code: 'demo',
  //         id: 470,
  //         title: '三一重卡',
  //         value: 470,
  //       },
  //       {
  //         has_children: true,
  //         children: [
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 473,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 476,
  //             title: '泵送专家',
  //             value: 476,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 473,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 479,
  //             title: '重机专家',
  //             value: 479,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 473,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 482,
  //             title: '港机专家',
  //             value: 482,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 473,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 485,
  //             title: '石油专家',
  //             value: 485,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 473,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 488,
  //             title: '重能专家',
  //             value: 488,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 473,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 491,
  //             title: '重起专家',
  //             value: 491,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 473,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 494,
  //             title: '云游专家',
  //             value: 494,
  //           },
  //           {
  //             has_children: false,
  //             children: [],
  //             dept_sort: 0,
  //             dept_pid: 473,
  //             vcc_id: 1,
  //             vcc_code: 'demo',
  //             id: 497,
  //             title: '重装专家',
  //             value: 497,
  //           },
  //         ],
  //         dept_sort: 0,
  //         dept_pid: 1,
  //         vcc_id: 1,
  //         vcc_code: 'demo',
  //         id: 473,
  //         title: '专家在线',
  //         value: 473,
  //       },
  //     ],
  //     dept_sort: 0,
  //     dept_pid: 0,
  //     vcc_id: 1,
  //     vcc_code: 'demo',
  //     id: 1,
  //     title: '公司',
  //     value: 1,
  //   },
  // ], // 部门树
};

const list = (state = initialState, action) => {
  switch (action.type) {
    case `${GET_TASK_LIST_STRATEGY_OPTIONS}_SUCCESS`:
      return {
        ...state,
        wordStrategyIdOptionList: action.payload.data,
      };
    case `${GET_TASK_LIST_WORD_STRATEGY_ID_OPTIONS}_SUCCESS`:
      return {
        ...state,
        wordStrategyIdOptions: action.payload.data,
      };
    case `${GET_TASK_LIST_PHONE_OPTIONS}_SUCCESS`:
      return {
        ...state,
        phoneOptions: action.payload.data,
      };
    case `${TASK_LIST_DEPT}_SUCCESS`:
      return {
        ...state,
        treeData: action.payload.data.treeData,
        // treeData: [
        //   {
        //     has_children: true,
        //     children: [
        //       {
        //         has_children: true,
        //         children: [
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 2,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 8,
        //             title: '4567',
        //             value: 8,
        //           },
        //         ],
        //         dept_sort: 0,
        //         dept_pid: 1,
        //         vcc_id: 1,
        //         vcc_code: 'demo',
        //         id: 2,
        //         title: '213',
        //         value: 2,
        //       },
        //       {
        //         has_children: false,
        //         children: [],
        //         dept_sort: 0,
        //         dept_pid: 1,
        //         vcc_id: 1,
        //         vcc_code: 'demo',
        //         id: 14,
        //         title: '789',
        //         value: 14,
        //       },
        //       {
        //         has_children: true,
        //         children: [
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 26,
        //             title: '宁乡重起-咸阳泰瑞达',
        //             value: 26,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 32,
        //             title: '宁乡重起-甘肃天源',
        //             value: 32,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 38,
        //             title: '宁乡重起-宁夏三川',
        //             value: 38,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 44,
        //             title: '宁乡重起-新疆华誉',
        //             value: 44,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 50,
        //             title: '宁乡重起-云南肯瑞',
        //             value: 50,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 56,
        //             title: '宁乡重起-贵州大驰',
        //             value: 56,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 62,
        //             title: '宁乡重起-四川鹏烜',
        //             value: 62,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 68,
        //             title: '宁乡重起-四川中安信',
        //             value: 68,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 74,
        //             title: '宁乡重起-巴州邦立华',
        //             value: 74,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 80,
        //             title: '宁乡重起-重庆湘汇',
        //             value: 80,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 86,
        //             title: '宁乡重起-广西聚缘和',
        //             value: 86,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 92,
        //             title: '宁乡重起-深圳沃拓',
        //             value: 92,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 98,
        //             title: '宁乡重起-广州巨合',
        //             value: 98,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 104,
        //             title: '宁乡重起-广州山屹',
        //             value: 104,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 110,
        //             title: '宁乡重起-湖南大驰',
        //             value: 110,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 116,
        //             title: '宁乡重起-湖北鸿辉',
        //             value: 116,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 122,
        //             title: '宁乡重起-郑州合顺',
        //             value: 122,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 128,
        //             title: '宁乡重起-烟台宏力达',
        //             value: 128,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 134,
        //             title: '宁乡重起-临沂冠泰',
        //             value: 134,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 140,
        //             title: '宁乡重起-江西九象',
        //             value: 140,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 146,
        //             title: '宁乡重起-杭州九象',
        //             value: 146,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 152,
        //             title: '宁乡重起-厦门博威特',
        //             value: 152,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 158,
        //             title: '宁乡重起-唐山驰特',
        //             value: 158,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 164,
        //             title: '宁乡重起-南京凯雷',
        //             value: 164,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 170,
        //             title: '宁乡重起-连云港广德',
        //             value: 170,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 176,
        //             title: '宁乡重起-江苏振轩',
        //             value: 176,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 182,
        //             title: '宁乡重起-哈尔滨永德',
        //             value: 182,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 188,
        //             title: '宁乡重起-吉林锐众',
        //             value: 188,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 194,
        //             title: '宁乡重起-沈阳三益源',
        //             value: 194,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 200,
        //             title: '宁乡重起-大连金威特',
        //             value: 200,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 206,
        //             title: '宁乡重起-山西北起',
        //             value: 206,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 212,
        //             title: '宁乡重起-唐山泉源',
        //             value: 212,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 218,
        //             title: '宁乡重起-河北宝域',
        //             value: 218,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 20,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 224,
        //             title: '宁乡重起-华北宝思威',
        //             value: 224,
        //           },
        //         ],
        //         dept_sort: 0,
        //         dept_pid: 1,
        //         vcc_id: 1,
        //         vcc_code: 'demo',
        //         id: 20,
        //         title: '长沙宁乡重起总部',
        //         value: 20,
        //       },
        //       {
        //         has_children: false,
        //         children: [],
        //         dept_sort: 0,
        //         dept_pid: 1,
        //         vcc_id: 1,
        //         vcc_code: 'demo',
        //         id: 230,
        //         title: '三一互动营销中心',
        //         value: 230,
        //       },
        //       {
        //         has_children: false,
        //         children: [],
        //         dept_sort: 0,
        //         dept_pid: 1,
        //         vcc_id: 1,
        //         vcc_code: 'demo',
        //         id: 236,
        //         title: '三一重工国际总部服务热线',
        //         value: 236,
        //       },
        //       {
        //         has_children: false,
        //         children: [],
        //         dept_sort: 0,
        //         dept_pid: 1,
        //         vcc_id: 1,
        //         vcc_code: 'demo',
        //         id: 242,
        //         title: '董办服务配件组投诉',
        //         value: 242,
        //       },
        //       {
        //         has_children: false,
        //         children: [],
        //         dept_sort: 0,
        //         dept_pid: 1,
        //         vcc_id: 1,
        //         vcc_code: 'demo',
        //         id: 248,
        //         title: '长沙路机事业部',
        //         value: 248,
        //       },
        //       {
        //         has_children: true,
        //         children: [
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 254,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 260,
        //             title: '昆山重机-武汉九州龙',
        //             value: 260,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 254,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 266,
        //             title: '昆山重机-郑州湘元',
        //             value: 266,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 254,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 272,
        //             title: '昆山重机-临沂亚华',
        //             value: 272,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 254,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 278,
        //             title: '昆山重机-烟台宏通',
        //             value: 278,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 254,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 284,
        //             title: '昆山重机-江西中旺',
        //             value: 284,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 254,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 290,
        //             title: '昆山重机-广州巨和',
        //             value: 290,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 254,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 296,
        //             title: '昆山重机-福建闽瑞通',
        //             value: 296,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 254,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 302,
        //             title: '昆山重机-合肥湘元',
        //             value: 302,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 254,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 308,
        //             title: '昆山重机-杭州鼎腾',
        //             value: 308,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 254,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 314,
        //             title: '昆山重机-江苏力好',
        //             value: 314,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 254,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 320,
        //             title: '昆山重机-黑龙江三君',
        //             value: 320,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 254,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 326,
        //             title: '昆山重机-石家庄众力',
        //             value: 326,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 254,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 332,
        //             title: '昆山重机-宜昌博勒',
        //             value: 332,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 254,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 338,
        //             title: '昆山重机-包头弘达',
        //             value: 338,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 254,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 344,
        //             title: '昆山重机-山西三龙聚兴',
        //             value: 344,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 254,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 350,
        //             title: '昆山重机-承德鸿泰',
        //             value: 350,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 254,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 356,
        //             title: '昆山重机-广西山宁',
        //             value: 356,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 254,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 362,
        //             title: '昆山重机-湖南中旺',
        //             value: 362,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 254,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 368,
        //             title: '昆山重机-重庆国杰',
        //             value: 368,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 254,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 374,
        //             title: '昆山重机-云南睿德',
        //             value: 374,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 254,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 380,
        //             title: '昆山重机-陕西悦大',
        //             value: 380,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 254,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 386,
        //             title: '昆山重机-宁夏三益',
        //             value: 386,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 254,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 392,
        //             title: '昆山重机-甘肃成峰',
        //             value: 392,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 254,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 398,
        //             title: '昆山重机-张掖海峰',
        //             value: 398,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 254,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 404,
        //             title: '昆山重机-青海海畴',
        //             value: 404,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 254,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 410,
        //             title: '昆山重机-新疆京泓',
        //             value: 410,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 254,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 416,
        //             title: '昆山重机-吉林三君',
        //             value: 416,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 254,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 422,
        //             title: '昆山重机-四川盛和',
        //             value: 422,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 254,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 428,
        //             title: '昆山重机-贵州通程兄弟',
        //             value: 428,
        //           },
        //         ],
        //         dept_sort: 0,
        //         dept_pid: 1,
        //         vcc_id: 1,
        //         vcc_code: 'demo',
        //         id: 254,
        //         title: '江苏昆山重机总部',
        //         value: 254,
        //       },
        //       {
        //         has_children: false,
        //         children: [],
        //         dept_sort: 0,
        //         dept_pid: 1,
        //         vcc_id: 1,
        //         vcc_code: 'demo',
        //         id: 434,
        //         title: '三一员工服务中心(IT帮助台)',
        //         value: 434,
        //       },
        //       {
        //         has_children: false,
        //         children: [],
        //         dept_sort: 0,
        //         dept_pid: 1,
        //         vcc_id: 1,
        //         vcc_code: 'demo',
        //         id: 440,
        //         title: '三一物流',
        //         value: 440,
        //       },
        //       {
        //         has_children: false,
        //         children: [],
        //         dept_sort: 0,
        //         dept_pid: 1,
        //         vcc_id: 1,
        //         vcc_code: 'demo',
        //         id: 446,
        //         title: '长沙泵送事业部',
        //         value: 446,
        //       },
        //       {
        //         has_children: false,
        //         children: [],
        //         dept_sort: 0,
        //         dept_pid: 1,
        //         vcc_id: 1,
        //         vcc_code: 'demo',
        //         id: 452,
        //         title: '三一快而居公司',
        //         value: 452,
        //       },
        //       {
        //         has_children: false,
        //         children: [],
        //         dept_sort: 0,
        //         dept_pid: 1,
        //         vcc_id: 1,
        //         vcc_code: 'demo',
        //         id: 458,
        //         title: '公司总部',
        //         value: 458,
        //       },
        //       {
        //         has_children: false,
        //         children: [],
        //         dept_sort: 0,
        //         dept_pid: 1,
        //         vcc_id: 1,
        //         vcc_code: 'demo',
        //         id: 464,
        //         title: '三一物联网（租赁平台）',
        //         value: 464,
        //       },
        //       {
        //         has_children: true,
        //         children: [
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 470,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 472,
        //             title: '测试三一重卡下级节点',
        //             value: 472,
        //           },
        //         ],
        //         dept_sort: 0,
        //         dept_pid: 1,
        //         vcc_id: 1,
        //         vcc_code: 'demo',
        //         id: 470,
        //         title: '三一重卡',
        //         value: 470,
        //       },
        //       {
        //         has_children: true,
        //         children: [
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 473,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 476,
        //             title: '泵送专家',
        //             value: 476,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 473,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 479,
        //             title: '重机专家',
        //             value: 479,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 473,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 482,
        //             title: '港机专家',
        //             value: 482,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 473,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 485,
        //             title: '石油专家',
        //             value: 485,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 473,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 488,
        //             title: '重能专家',
        //             value: 488,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 473,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 491,
        //             title: '重起专家',
        //             value: 491,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 473,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 494,
        //             title: '云游专家',
        //             value: 494,
        //           },
        //           {
        //             has_children: false,
        //             children: [],
        //             dept_sort: 0,
        //             dept_pid: 473,
        //             vcc_id: 1,
        //             vcc_code: 'demo',
        //             id: 497,
        //             title: '重装专家',
        //             value: 497,
        //           },
        //         ],
        //         dept_sort: 0,
        //         dept_pid: 1,
        //         vcc_id: 1,
        //         vcc_code: 'demo',
        //         id: 473,
        //         title: '专家在线',
        //         value: 473,
        //       },
        //     ],
        //     dept_sort: 0,
        //     dept_pid: 0,
        //     vcc_id: 1,
        //     vcc_code: 'demo',
        //     id: 1,
        //     title: '公司',
        //     value: 1,
        //   },
        // ],
      };
    case `${GET_TASK_LIST_WORK_TIME_OPTIONS}_SUCCESS`:
      return {
        ...state,
        workTimeOptions: action.payload.data,
      };
    case `${SET_TASK_LIST_SEARCH_DATA}`:
      return {
        ...state,
        searchData: action.data,
      };
    case `${SET_TASK_LIST_TAB_ACTIVE_KEY}`:
      return {
        ...state,
        tabActiveKey: action.data,
      };
    case `${GET_TASK_LIST_LIST}_SUCCESS`:
      return {
        ...state,
        tableListData: {
          data: (action.payload.data && action.payload.data.list) || [],
          total: (action.payload.data && action.payload.data.total) || 0,
        },
      };
    case `${CUSTOMIZE_SMG_TEMPLATES}_SUCCESS`:
      return {
        ...state,
        templates: action.payload.data,
      };
    case `${GET_CUSTOMIZE_TASK_LIST}_SUCCESS`:
      return {
        ...state,
        tableListData: {
          data: (action.payload.data && action.payload.data.records) || [],
          total: (action.payload.data && action.payload.data.total) || 0,
        },
      };
    case `${GET_TASK_LIST_LIST}_FAIL`:
      return {
        ...state,
        tableListData: {
          data: [],
          total: 0,
        },
      };
    case `${SET_TASK_LIST_PAGE_STATUS}`:
      return {
        ...state,
        pageStatus: {...state.pageStatus, ...action.data},
      };
    case `${SET_TASK_LIST_EDIT_MODAL_DATA}`:
      return {
        ...state,
        editModalData: action.data,
      };
    default:
      return state;
  }
};

export default list;
